import React, { forwardRef } from 'react'
import { Checkbox } from 'antd'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { ForwardRefRenderFunction } from 'react'
import type { LntCheckboxProps } from './types'

const Component: ForwardRefRenderFunction<HTMLInputElement, LntCheckboxProps> = (props, ref) => {
  const {
    className: outerClassName,
    checked: rawChecked,
    indeterminate: rawIndeterminate,
    children,
    value,
    ...restProps
  } = props
  const checked: boolean = rawChecked ?? value
  const indeterminate = checked ? false : rawIndeterminate

  const className: string = classNames({ [styles.lntCheckbox_indeterminate]: indeterminate }, outerClassName)

  return (
    <Checkbox
      { ...restProps }
      className={ className }
      checked={ checked }
      indeterminate={ indeterminate }
      ref={ ref }
    >
      { children }
    </Checkbox>
  )
}

export const LntCheckbox = forwardRef<HTMLInputElement, LntCheckboxProps>(Component)
